import React, { useState, useEffect } from "react";
import qs from "qs";
import axios from "axios";
import * as constants from "../constants/domains";
import { toast } from "react-toastify";
import * as helpers from "../helpers/helpers";
import { useCookies } from "react-cookie";
import CountdownTimer from "../components/Counter";
//import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function Login(props) {
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [callBack, setCallBack] = useState("");
  const [passwordResetLoading, setPasswordResetLoading] = useState(false);
  const [site, setSite] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState({});
  const [addToSegment, setAddToSegment] = useState(false);
  const [timer, setTimer] = useState("");
  const [block, setBlock] = useState(false);
  const [ip, setIp] = useState(false);

  const { location, history } = props;

  const setCookie = useCookies(["user_server_token"])[1];
 // const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (!queryParams) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else if (
      queryParams["site"] !== "class" &&
      queryParams["site"] !== "shop"
    ) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else if (!queryParams["token"]) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else {
      try {
        setUsername(window.atob(queryParams["token"]));
      } catch (e) {
        history.push({
          pathname: "/user",
          search: "?site=shop",
        });
      }
      setSite(queryParams["site"]);
      setCallBack(queryParams["callBack"] ? queryParams["callBack"] : "");
    }

    if (queryParams && queryParams["addToSegment"] == "true") {
      setAddToSegment(true);
    } else {
      setAddToSegment(false);
    }
  }, [history, location]);


  function datalayer(username) {
        // if (typeof window !== "undefined" && typeof gtag === "function") {
        //     gtag('event', 'user_login', {
        //     username: username
        // });
    // }
    }

  // const datalayer = (username) => {
  //   const googleTagmanager = document.createElement("script");
  //   googleTagmanager.src = "/user/js/google_tagmanager.js";
  //   googleTagmanager.async = true;
  //   document.body.appendChild(googleTagmanager);
  //   googleTagmanager.onload = () => {
  //     window.dataLayer = window.dataLayer || [];
  //     window.dataLayer.push({
  //       event: "user_login",
  //       username: username,
  //     });
  //   };
  // };

  const formSubmit = (event) => {
    event.preventDefault();
    if (password !== "") {
      setLoading(true);
      setValidationError({});

      axios
        .post(constants.$apiUrl + "/api/login", {
          username: username,
          password: password,
          addToSegment: addToSegment ?? false,
        })
        .then((response) => {
          setLoading(false);
          datalayer(username);

          if (response.data.success) {
            let oneYear = Date.now() + 365 * 24 * 60 * 60 * 1000;

            setCookie("user_server_token", response.data.data.token, {
              domain: constants.$cookieURL,
              path: "/",
              expires: new Date(oneYear),
            });
            const callback = callBack ? callBack : "/";
            if (site === "class") {
              window.location.href = constants.$class_next_url + callback;
            } else {
              //window.location.href = constants.$shopUrl+'/site/checklogin?token='+response.data.data.token+'&callBack='+encodeURI(callback);
              window.location.href = callback?callback:constants.$shopUrl;
            }
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            if (error.response.status === 400) {
              setValidationError({ ...error.response.data.data });
              if (
                error.response.data.data.username &&
                error.response.data.data.username.length > 0
              ) {
                toast.error(
                  "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                  {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  }
                );
              }
            } else if (error.response.status === 409) {
              setValidationError({
                password: [error.response.data.message],
              });
            } else {
              toast.error(
                "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        });
    } else {
      setValidationError({ password: ["پسورد نمیتواند خالی باشد."] });
    }
  };

  const resetPassword = async (event) => {
    event.preventDefault();
 //   if (!executeRecaptcha) {
 //     alert("کپچا آماده نشده است !");
 //     event.stopPropagation();
 //     return;
 //   }
 //   const tokenRecaptcha = await executeRecaptcha("submit");
    setPasswordResetLoading(true);
    setValidationError({});

    axios
      .post(constants.$apiUrl + "/api/send-password-reset-token", {
        username: username,
 //       captcha:tokenRecaptcha,
      })
      .then((response) => {
        setPasswordResetLoading(false);

        if (response.data.success) {
          const search = qs.stringify({
            site: site,
            callBack: callBack,
            token: window.btoa(helpers.fa_to_eng_number(username)),
          });
          props.history.push({
            pathname: "/user/confirm-password-reset",
            search: "?" + search,
          });
        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      })
      .catch((error) => {
        setPasswordResetLoading(false);
        if (error.response) {
          if (error.response.status === 400) {
            if (error.response && error.response.data.data == "Limited") {
                if (error.response && error.response.data.limitTime > 0) {
                    setTimer(error.response.data.limitTime);
                  }
                  if (error.response && error.response.data.limitTime == -1) {
                    setBlock(true);
                    setIp(error.response.data.ip)

                  } else {
                    setBlock(false);
                    setIp(error.response.data.ip)

                  }
              toast.error(
                "تعداد درخواست های شما به سرور زیاد شده است لطفا در زمانی دیگر تلاش کنید",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
            setValidationError({ ...error.response.data.data });
            if (
              error.response.data.data.username &&
              error.response.data.data.username.length > 0
            ) {
              toast.error(
                "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          } else if (error.response.status === 409) {
            setValidationError({
              username: [error.response.data.message],
            });
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      });
  };

  return (
    <React.Fragment>
      <div className="container">
        <div className="card-group card-authentication mx-auto mb-5">
          <div className="login-card">
            <div className="card-content direction-rtl">
              <div className="form-header-logo">
                <img
                  src={constants.$authUrl + "/images/honari_logo.png"}
                  alt="هنری دات کام"
                />
                <div className="logo-text">
                  <p className="logo-honari-text">هـنـری</p>
                  <p className="logo-desc-text">تحقق رویای هنرمندانه‌ تو</p>
                </div>
              </div>
              <div className={"form-header"}>رمز عبور را وارد کنید</div>
              <form onSubmit={(event) => formSubmit(event)}>
                <div className="mb-4 row">
                  <label htmlFor="password" className={"login-mobile-message"}>
                    رمز عبور حساب کاربری خود را وارد کنید
                  </label>
                  <div className={"login-form-row"}>
                    <input
                      id="password"
                      type="password"
                      className={
                        "form-field " +
                        (validationError["password"] &&
                        Array.isArray(validationError["password"])
                          ? "not-valid "
                          : "")
                      }
                      autoFocus={"auto"}
                      onChange={(event) => setPassword(event.target.value)}
                      value={password}
                    />
                    {validationError["password"] &&
                    Array.isArray(validationError["password"])
                      ? validationError["password"].map((item, index) => {
                          return (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item,
                              }}
                              key={index}
                              className={"validation-error"}
                            ></div>
                          );
                        })
                      : null}
                  </div>
                </div>

                {timer > 0 && (
                    <div className="mt-3">
                      <span className="pb-4 text-danger">
                        بدلیل درخواست زیاد درخواست شما محدود شده است 
                      </span>
                      <div className="mt-2">
                        {" "}
                        <CountdownTimer minutes={timer} />
                      </div>
                    </div>
                  )}
                  {
                    block && <span className="pb-4  text-danger">
                    بدلیل درخواست زیاد درخواست شما محدود شده است لطفا با پشتیبانی تماس بگیرید
                    <br/>
                    <span>ip : {ip}</span>
                    <br/>
                  </span>
                  }

                {passwordResetLoading ? (
                  <span className={"forgot-password-pending"}>
                    در حال ارسال اطلاعات...
                  </span>
                ) : (
                  <span
                    className={"forgot-password-link"}
                    onClick={resetPassword}
                  >
                    بازیابی رمز عبور
                  </span>
                )}

                <div className="row">
                  <div className={"my-3"}>
                    {loading ? (
                      <button
                        disabled={true}
                        className="btn btn-honari w-100 py-2"
                      >
                        در حال ارسال اطلاعات...
                      </button>
                    ) : (
                      <button className="btn btn-honari w-100 py-2">
                        ادامه
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
